//
//
//
//
//
//

export default {
    props: {
        maxStars: {
            type: Number,
            validator: (val) => val > 0,
        },
        percentValue: {
            type: Number,
            validator: (val) => 100 >= val && val >= 0,
        },
    },
    computed: {
        starArray() {
            return [...Array(this.starCount)];
        },
        remainingStars() {
            return [...Array(this.maxStars - this.starCount)];
        },
        starCount() {
            return parseInt(((this.percentValue / 100) * this.maxStars).toFixed(0)) || 0;
        },
    },
};
